import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useUIStore } from "../../stores/uiStore";

export function AppLayout() {
  const location = useLocation();
  const { mobileMenuOpen, closeMobileMenu } = useUIStore();

  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Mobile drawer backdrop */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 md:hidden backdrop-blur-xs"
          onClick={closeMobileMenu}
        />
      )}

      {/* Sidebar — desktop static, mobile off-canvas drawer */}
      <div
        className={`fixed inset-y-0 left-0 z-50 md:static md:z-auto md:flex md:shrink-0 transform transition-transform duration-300 ease-in-out ${
          mobileMenuOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        }`}
      >
        <Sidebar />
      </div>

      {/* Main app surface */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-muted/20">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
